import{CARD_OPTIONS_UPDATE_REQUEST, CARD_OPTIONS_UPDATE_SUCCESS, CARD_OPTIONS_UPDATE_FAIL} from "../../actions/types";

const initialState = {
    members: [],

    isLoading: false,
    error: null,

    credits: null,

    currentBlock: { idx: 0, id: null },

    fontStyle: null,

    googleSheetLink: null,
    googleSpreadSheetId: null,
 
    lastSaved: null,
    lastSavedTime: new Date(),
    logos: [],  

    settings: null,

    isVideoGenerated: null,
    renders: [],
  };

const CardEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CARD_OPTIONS_UPDATE_REQUEST:
        return {
            ...state,
            isLoading: true
        };

    case CARD_OPTIONS_UPDATE_SUCCESS:
        return {
            ...state,
            isLoading: false,
            payload: action.payload
        }
    
    case CARD_OPTIONS_UPDATE_FAIL:
        return {
            ...state,
            isLoading: false,
            error: action.payload.error,
        };
  
    default:
       return state;
  }
}

export default CardEditReducer;